import { SimulationLoopService } from './../../services/simulation-loop.service';
import { AfterViewInit, Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { LinkService } from '../../services/link.service';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PredictorModelState } from 'src/app/state/predictor-model/predictor-model.state';
import { StudyArea } from '../../interfaces/study-area';
import { PredictorModelActions } from 'src/app/state/predictor-model/predictor-model.actions';
import { APP_CONFIG, AppConfig } from 'src/app/appconfig/appconfig';
import { CanvasService } from '../../services/canvas.service';
import { Dropdown } from 'primeng/dropdown';
import { SimulationService } from '../../services/simulation.service';
import { SimulationRendererService } from '../../services/simulation-renderer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserState } from 'src/app/state/user/user.state';
import { UserActions } from 'src/app/state/user/user.actions';

@Component({
  selector: 'app-accordion-column',
  templateUrl: './accordion-column.component.html',
  styleUrls: ['./accordion-column.component.scss'],
})
export class AccordionColumnComponent implements OnDestroy, AfterViewInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  /** dropdown model */
  selectedStudyArea?: StudyArea | null = null;

  @Select(PredictorModelState.selectedSimulationId)
  selectedSimulationId$!: Observable<string | null>;

  @Select(PredictorModelState.terrainState)
  terrainState$!: Observable<string | null>;

  @Select(PredictorModelState.terrainLoaded)
  terrainLoaded$!: Observable<boolean | null>;

  @Select(PredictorModelState.selectedStudyArea)
  selectedStudyArea$!: Observable<StudyArea | null>;

  @Select(PredictorModelState.selectedStudyAreaData)
  selectedStudyAreaData$!: Observable<any>;

  @Select(PredictorModelState.groupedStudyAreas)
  groupedStudyAreas$!: Observable<any>;


  @ViewChild('dropdown') dropdown!: Dropdown;

  constructor(
    private store: Store,
    private canvasService: CanvasService,
    public simulationLoopService: SimulationLoopService,
    public simulationService: SimulationService,
    private renderService: SimulationRendererService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) { }

  ngAfterViewInit() {
    this.store
    .select(PredictorModelState.openStudyAreaDropDown)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((open) => {
      if (open) {
        this.dropdown.show();
      }
    });
  }

  showSimulationDetails(): boolean {
    return this.renderService.runDetails !== undefined && this.renderService.runDetails !== null;
  }

  studyAreaChanged(event: { originalEvent: Event; value: StudyArea }) {
    this.store.dispatch(
      new PredictorModelActions.SetSelectedStudyArea(event.value.id, event.value.studyAreaName,event.value.licenseNumber)
    );

    // Force the dropdown to refresh and show placeholder
    setTimeout(() => {
      this.selectedStudyArea = null;
    });

    this.dropdown.filterValue = ''; // Clear the filter text
    this.dropdown.resetFilter();    // Reset the filter

    this.canvasService.clearCanvas();
    this.simulationLoopService.reset();

    if (this.router.url === "/predictor") {
      this.router.navigate([event.value.id], { relativeTo: this.route });
    }
    else {
      this.router.navigate(["../", event.value.id], { relativeTo: this.route });
    }
  }

  openPricingTool() {  

    this.store.dispatch(new UserActions.GetLicenseAccess()).subscribe(() => {
    const isActiveLicenseAccess = this.store.selectSnapshot(UserState.userLicenseAccess);

      if (isActiveLicenseAccess?.licenseNumber != null) {
        this.router.navigate(["/studyarea"]);
      } else {
        LinkService.OpenExternalLink(this.appConfig.pricingToolLink);
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onAccessChange(value: any) {
  console.info('Access changed in child component.', value);
          this.dropdown.hide();
  // You can now do anything—close another dropdown, update state, etc.
}
}
